var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "Cups-DetailsSection",
        { attrs: { title: "Cliente" } },
        [_c("Core-DataSection", { attrs: { elements: _vm.generalElements } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }